import { connect } from 'react-redux'

import LegacyTodayPage from './LegacyTodayPage'
import { fetchAd, fetchAdCount, updateAdForcedStop } from '../actions'

const mapStateToProps = state => ({
  ad: state.today.ad,
  isExpanderLoading: state.today.loading.expander,
})

const mapDispatchToProps = dispatch => ({
  onAd: params => dispatch(fetchAd(params)),
  onAdCount: params => dispatch(fetchAdCount(params)),
  onUpdateAdForcedStop: data => dispatch(updateAdForcedStop(data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(LegacyTodayPage)
